import { useScreenSize } from './useScreenSize';

export const useWidowKiller = (text) => {
  const screenSize = useScreenSize();
  if (!text) return null;
  if (screenSize > 576) {
    const lastSpace = text.lastIndexOf(' ');
    const textWithoutWidows =
      text.substring(0, lastSpace) + '\u00a0' + text.substring(lastSpace + 1).replaceAll('-', '\u2011');
    return textWithoutWidows;
  } else return text;
};
